module.exports = __webpack_public_path__ + "img/6_of_Spades.svg.1c755e07.png";